Array.prototype.append = (el) ->
  this.push el if this.push?
  this
   
document.addEventListener 'DOMContentLoaded', () ->
	